import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { SummaryRow } from '@cosmos/shared';
import { ColumnDefinition } from '../../../data/data-table/column-definition.model';
import { SummaryConfigContext, SummaryTableModel, SummaryTypeUi } from './summary-type-ui.model';

const col = (name: string, label: string, type?: string, rightBorder = false): ColumnDefinition => ({
  name, label, visible: true, sortable: true, draggable: false, type, rightBorder,
});

export const temperatureSummaryUi: SummaryTypeUi = {
  configFields(ctx: SummaryConfigContext): FormlyFieldConfig[] {
    return [{
      key: 'averageCheckpoints', type: 'chips-number', wrappers: ['default-wrapper'],
      props: { label: ctx.translate.instant('summarize-measurements.config.averageCheckpoints'), suffix: ' d' },
    }];
  },

  validate(model): boolean {
    return !!(model?.['averageCheckpoints'] as number[] | undefined)?.length;
  },

  buildTable(rows: SummaryRow[], config: Record<string, unknown>, translate: TranslateService): SummaryTableModel {
    const cps = (config['averageCheckpoints'] as number[]) ?? [];
    const t = (k: string, p?: object) => translate.instant(k, p);

    const columns: ColumnDefinition[] = [
      col('name', t('table.labels.name')),
      col('stageName', t('table.labels.stage')),
      col('startTime', t('table.labels.startDate'), 'date'),
      col('avgTemp', t('table.labels.avgTemp'), 'number'),
      col('maxTemp', t('table.labels.maxTemp'), 'number'),
      col('minTemp', t('table.labels.minTemp'), 'number', true),
    ];
    for (const cp of cps) {
      columns.push(
        col(`averageCheckpoints.${cp}.avgTemp`, t('table.labels.avgTempFromDay', { cp }), 'number'),
        col(`averageCheckpoints.${cp}.maxTemp`, t('table.labels.maxTempFromDay', { cp }), 'number'),
        col(`averageCheckpoints.${cp}.minTemp`, t('table.labels.minTempFromDay', { cp }), 'number', true),
      );
    }

    const data = rows.map(row => {
      const out: Record<string, unknown> = {
        name: row.name, stageName: row.stageName ?? '-', startTime: row.startTime,
        avgTemp: row.avgTemp, maxTemp: row.maxTemp, minTemp: row.minTemp,
      };
      const map: Record<string, unknown> = {};
      for (const c of row.averageCheckpoints ?? []) map[c.checkpoint] = c;
      out['averageCheckpoints'] = map;
      return out;
    });

    return { columns, data };
  },
};
